import React, { useMemo, useState, useContext, useEffect } from "react";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { Button, Card, Input, message, Popover, Transfer, Typography } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProgressBar from "./ProgressBar";
import axios from "axios";
import { HomeContext } from "../Context";
import { getMyClientReportColumns, getMyCensusReportColumns } from "../../Services/auth";
import Title from "antd/lib/skeleton/Title";

const { Text } = Typography;

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function DownloadReport({ clientFlag, disable, Filters, emailReport = false }) {
	const { downloadReport, tenant } = useContext(HomeContext);
	const [loadingdata, setLoadingData] = useState({
		abbr: "No Action",
		percent: null
	});
	let data = useMemo(() => {
		let reportColumns = [];
		if (!clientFlag) reportColumns = getMyCensusReportColumns() || [];
		else reportColumns = getMyClientReportColumns() || [];

		return reportColumns.map(({ key, name }) => ({
			key,
			title: name,
			description: key
		}));
	}, [tenant, clientFlag]);

	const [{ cancelToken, loading }, setData] = useState({ cancelToken: null, loading: false });
	const [popOverOpen, setPopOverOpen] = useState(false);
	const [targetKeys, setTargetKeys] = useState([]);
	const [selectedKeys, setSelectedKeys] = useState([]);
	const [email, setEmail] = useState("");
	const isEmailValid = email === "" || EMAIL_REGEX.test(email);

	const onDownloadProgress = progressEvent => {
		const { loaded, total } = progressEvent;
		const divisor = 1048576;
		const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
		setLoadingData({ abbr: "Mbs", loaded, total, divisor, percent });
	};

	useEffect(() => {
		if (data) {
			setTargetKeys(data.map(({ key }) => key));
		}
	}, [data]);

	return (
		<>
			<Popover
				open={popOverOpen}
				onOpenChange={value => setPopOverOpen(value)}
				content={
					<div className="flex-row " style={{ width: "60vh" }}>
						<div className="w-100 d-flex">
							<Card bodyStyle={{ padding: 16 }}>
								{emailReport && (
									<>
										<Title level={5} style={{ margin: 0 }}>
											Enter Email Address
										</Title>
										<Text type="secondary">We’ll send the report link to this address.</Text>

										<Input
											status={email && !isEmailValid ? "error" : undefined}
											style={{ marginTop: 8, marginBottom: 8 }}
											type="email"
											placeholder="you@example.com"
											value={email}
											onChange={e => setEmail(e.target.value)}
										/>
									</>
								)}
								<Button
									className="blueclr"
									loading={loading}
									disabled={targetKeys.length === 0}
									color="primary"
									onClick={async () => {
										try {
											if (emailReport) {
												if (!email || !isEmailValid) {
													message.error("Please enter a valid email address.");
													return;
												}
											}
											const source = axios.CancelToken.source();

											setLoadingData({
												abbr: "Waiting For Server Response",
												percent: null
											});

											setData({ cancelToken: source, loading: true });

											await downloadReport({
												Filters,
												onDownloadProgress,
												cancelToken: source.token,
												targetKeys: data
													.filter(({ key }) => targetKeys.includes(key))
													.map(item => item),
												clientFlag,
												email,
												emailReport
											});
											setEmail("");
											setLoadingData({ abbr: "Completed", percent: null });
											setData({ cancelToken: null, loading: false });
										} catch ({ message }) {
											setData({ cancelToken: null, loading: false });

											setLoadingData({ abbr: message, percent: null });
										}
									}}
								>
									Download Report
								</Button>
							</Card>
						</div>

						<div className="mt-2 w-100">
							<Transfer
								listStyle={{ flex: "none", width: "45.5%" }}
								dataSource={data}
								titles={["Available", "Selected"]}
								targetKeys={targetKeys}
								selectedKeys={selectedKeys}
								onChange={nextTargetKeys => setTargetKeys(nextTargetKeys)}
								onSelectChange={(sourceSelectedKeys, targetSelectedKeys) =>
									setSelectedKeys([...targetSelectedKeys, ...sourceSelectedKeys])
								}
								render={item => item.title}
							/>
						</div>

						{cancelToken !== null && (
							<div className="flex-row pt-3">
								<div>
									<h6>Download Progress</h6>
								</div>
								{
									<div className="pt-3 pl-3">
										<Button
											onClick={() => {
												cancelToken.cancel("Operation canceled by the user.");
											}}
										>
											Click To Cancel Request{" "}
										</Button>
									</div>
								}
								<div className="pt-3 pl-3">
									<ProgressBar data={loadingdata} />
								</div>
							</div>
						)}
					</div>
				}
				title="Download Report"
			>
				{tenant !== "ISMAIL_INDUSTRIES" && tenant !== "PG_PHL" && (
					<Button
						className="blueclr"
						disabled={disable}
						loading={loading}
						onMouseEnter={() => setPopOverOpen(true)}
						// onMouseLeave={() => setPopOverOpen(false)}
						onClick={() => setPopOverOpen(!popOverOpen)}
					>
						<FontAwesomeIcon className="mr-2" icon={faDownload} />
						{clientFlag ? "Client Data" : "Census outlets"}
					</Button>
				)}
			</Popover>
		</>
	);
}

export default DownloadReport;
